module.exports = __webpack_public_path__ + "img/9788952765215.11242abb.jpg";